export default "__VITE_ASSET__D8jnJ_OP__"